import React from "react";

const Footer1 = (props) => {
  return (
    <footer class={props?.matchFound===false?"wipro-footer footerdown":"wipro-footer"}>
      <div>
        <p>© 2022 Wipro Limited</p>
      </div>
    </footer>
  );
};
export default Footer1;
